import BaseMarker from "./BaseMarker";
import * as THREE from 'three';
import { markRaw } from 'vue';

export default class HotSpotMarker extends BaseMarker {
    inspectionAreaId = null;
    numberOfMarkers = null;
    averageCriticality = null;
    thumbnailPath = null;
    anomalyIds = [];
    label = null;
    lastUpdatedOn = null;
    isActive = null;

    constructor(marker) {
        super(marker.id, marker.label, marker.assetId, marker.scanId, marker.transform, marker.eTag);
        this.inspectionAreaId = marker.inspectionAreaId;
        this.numberOfMarkers = marker.numberOfMarkers;
        this.averageCriticality = marker.averageCriticality;
        this.thumbnailPath = marker.thumbnailPath;
        this.anomalyIds = marker.anomalyIds;
        this.isActive = marker.isActive;

        this.label = marker.label;
        this.lastUpdatedOn = marker.lastUpdatedOn;

        this.generateMesh();
    }

    generateMesh() {
        const position = new THREE.Vector3(
            this.transform.position.x,
            this.transform.position.y,
            this.transform.position.z
        );

        const size = Math.max(
            Math.abs(this.transform.scale.x),
            Math.abs(this.transform.scale.y),
            Math.abs(this.transform.scale.z)
        );

        const geometry = new THREE.DodecahedronGeometry(1, 1);

        const coreMaterial = new THREE.MeshBasicMaterial({
            color: 0x66C7B4,
            transparent: true,
            opacity: 0.5
        });

        const dodecahedron = new THREE.Mesh(geometry, coreMaterial);
        dodecahedron.userData.markerId = this.id;

        const edges = new THREE.EdgesGeometry(geometry);
        const outlineMaterial = new THREE.LineBasicMaterial({
            color: 0x1E4D44,
            linewidth: 1
        });
        const outline = new THREE.LineSegments(edges, outlineMaterial);

        const group = new THREE.Group();
        group.add(dodecahedron);
        group.add(outline);

        group.position.copy(position);

        // hotspot is uniform
        group.scale.set(size, size, size);

        group.userData.markerId = this.id;

        this.meshGroup = markRaw(group);
    }

    animate() {
        this.meshGroup.rotation.y += 0.003;
        this.meshGroup.rotation.x += 0.003;
    }

    stopAnimation() {
        this.meshGroup.rotation.y -= 0.003;
        this.meshGroup.rotation.x -= 0.003;
    }
}
